import dispatcher from './../dispatcher/dispatcher';
import axios from 'axios';
let url = process.env.REACT_APP_BASE_URL || "http://triplemars.com:5001/api/auth-service"

let env_suffix=/api-dev/.test(url) ?
    '-dev' :
    /api-test/.test(url) ? '-test' : '';

export function login(data){
    axios({
        method:'get',
        url:url+'/auth',
        headers:{
            "Authorization":"xBasic "+btoa(data.email+':'+data.password)
        }
    }).then((response)=>{
        dispatcher.dispatch({
            type:'LOGIN_SUCCESS',
            data:{...response, env_suffix}
        })
    }).catch((err)=>{
        dispatcher.dispatch({
            type:'LOGIN_ERROR',
            data:err
        })
    })
}

export function socialLogin(data){
    axios({
        method:'post',
        url:url+'/socialAuth',
        data:data
    }).then((response)=>{
        console.log(response)
        dispatcher.dispatch({
            type:'LOGIN_SUCCESS',
            data:{...response, env_suffix}
        })
    }).catch((err)=>{
        dispatcher.dispatch({
            type:'LOGIN_ERROR',
            data:err
        })
    })
}

export function register(data,token){
    axios({
        method:'post',
        url: url+'/users',
        headers:{
            "Authorization":"Bearer "+token
        },
        data:data
    }).then((response)=>{
        dispatcher.dispatch({
            type:'REGISTER_SUCCESS',
            data:response
        });
        window.fbq('track', 'StartTrial', {
            currency: "USD",
            value: 0,
        });
        window.LeadDyno.recordLead(data.email);
    }).catch((err)=>{
        dispatcher.dispatch({
            type:'REGISTER_ERROR',
            data:err
        })
    })
}

export function forgotPassword(data, token){
    axios({
        method:'post',
        url: url + '/forgotPassword',
        headers:{
            "Authorization":"Bearer "+token
        },
        data:{email:data}
    }).then((response)=>{
        dispatcher.dispatch({
            type:'FORGOT_PASSWORD_SUCCESS',
            data:response
        })
    })
}

export function setPassword(data){
    axios({
        method:'post',
        url: url+'/setPassword',
        data: data
    }).then((response)=>{
        dispatcher.dispatch({
            type:'SET_PASSWORD_SUCCESS',
            data:{...response, env_suffix}
        })
    }).catch((err)=>{
        dispatcher.dispatch({
            type:'SET_PASSWORD_ERROR',
            data:err
        })
    })
}

export function verifyEmail(data){
    axios({
        method:'post',
        url: url+'/verifyEmail',
        data: data
    }).then((response)=>{
        dispatcher.dispatch({
            type:'VERIFY_EMAIL_SUCCESS',
            data:{...response, env_suffix}
        })
    }).catch((err)=>{
        dispatcher.dispatch({
            type:'VERIFY_EMAIL_ERROR',
            data:err
        })
    })
}

export function changePassword(data,token){
    axios({
        method:'post',
        url:url+'/changePassword',
        data:{
            token:token,
            password:data.password,
            re_password:data.re_password
        }
    }).then((response)=>{
        dispatcher.dispatch({
            type:'CHANGE_PASSWORD_SUCCESS',
            data:response
        })
    })
}

export function isAuth(token){
    axios({
        method:'get',
        url:url+'/isAuth',
        headers:{
            "Authorization":"Bearer "+token
        }
    }).then((response)=>{
        dispatcher.dispatch({
            type:'AUTH_SUCCESS',
            data:response
        })
    })
}
